import HttpRequest from '@/plugins/axios'

class PublicProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  async getCurrentYear(level_id) {
    const { data } = await this.get('/', {
      function: 'get-current-year',
      level_id: level_id,
    })
    return data
  }
  //===========================================================================
  async getRegistrarFacultyPostGraduate(faculty_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-faculty',
      faculty_id,
    })
    return data
  }

  async getRegistrarFacultyGraduate(faculty_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-faculty-x',
      faculty_id,
    })
    return data
  }

  async getRegistrarFacultyCurrPostGraduate(faculty_id, curr2_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-faculty-curr2',
      faculty_id,
      curr2_id,
    })
    return data
  }

  async getRegistrarFacultyCurrGraduate(faculty_id, curr_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-faculty-x-curr',
      faculty_id,
      curr_id,
    })
    return data
  }
  
  async getStudentList(level_id, faculty_id, curriculum_id) {
    const { data } = await this.get('/', {
      function: 'get-student-list',
      level_id,
      faculty_id,
      curriculum_id,
    })
    return data
  }

}
export default PublicProvider